/*
  7 September 2026. LEVEL 2 DRILL-DOWN FOR THE MOBILE MENU DRAWER.

  Markup: snippets/drawer-menu-items.liquid, current_level 2, context 'js'.
  Styles: assets/lwc-drawer-drilldown.css.

  WHY THIS IS NOT IN assets/component-drawer-menu.js. That file is single level
  by construction: closeAllSubmenusExcept() runs
  this.mainLevel.querySelectorAll('[data-accordion-item].is-open'), a descendant
  query, so anything nested that carried data-accordion-item would be found and
  closed by it. Level 2 therefore has its own attributes, which nothing else in
  the theme queries, and its own listeners. component-drawer-menu.js is
  unmodified and level 1 still behaves exactly as it did.

  Delegated from document, so it does not care when the drawer markup arrives or
  how many drill-downs there are.
*/
(function () {
  'use strict';

  /* One set of listeners even if the drawer snippet is ever rendered twice. */
  if (window.lwcDrawerDrilldownReady) return;
  window.lwcDrawerDrilldownReady = true;

  var OPEN = 'is-open';

  function closest(node, selector) {
    if (!node || !node.closest) return null;
    return node.closest(selector);
  }

  function trigger(dd) {
    return dd.querySelector('[data-lwc-dd-trigger]');
  }

  function open(dd) {
    if (!dd || dd.classList.contains(OPEN)) return;
    dd.classList.add(OPEN);
    var t = trigger(dd);
    if (t) t.setAttribute('aria-expanded', 'true');

    /* Move focus to the panel heading once the slide has finished, so a screen
       reader announces the category the shopper has just entered rather than
       reading from the row they left. */
    var heading = dd.querySelector('[data-lwc-dd-heading]');
    if (heading) {
      window.setTimeout(function () {
        if (!dd.classList.contains(OPEN)) return;
        try { heading.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
      }, 320);
    }
  }

  function close(dd, refocus) {
    if (!dd || !dd.classList.contains(OPEN)) return;
    dd.classList.remove(OPEN);
    var t = trigger(dd);
    if (!t) return;
    t.setAttribute('aria-expanded', 'false');
    if (refocus) {
      try { t.focus({ preventScroll: true }); } catch (e) { /* older browsers */ }
    }
  }

  function closeAll() {
    var openPanels = document.querySelectorAll('[data-lwc-dd].' + OPEN);
    for (var i = 0; i < openPanels.length; i++) {
      close(openPanels[i], false);
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    var openTrigger = closest(target, '[data-lwc-dd-trigger]');
    if (openTrigger) {
      event.preventDefault();
      var dd = closest(openTrigger, '[data-lwc-dd]');
      if (!dd) return;
      /* Only one level 2 panel open at a time, the same rule level 1 follows. */
      var siblings = document.querySelectorAll('[data-lwc-dd].' + OPEN);
      for (var i = 0; i < siblings.length; i++) {
        if (siblings[i] !== dd) close(siblings[i], false);
      }
      open(dd);
      return;
    }

    var backButton = closest(target, '[data-lwc-dd-back]');
    if (backButton) {
      event.preventDefault();
      close(closest(backButton, '[data-lwc-dd]'), true);
      return;
    }

    /* Anything that leaves or resets level 1 must also reset level 2, so the
       drawer always reopens at the root and never mid-menu:
         [data-close]                  the drawer close button, in every header
         [data-overlay]                the backdrop
         [data-drawer-submenu-close]   the level 1 back chevron
         [data-drawer-submenu-trigger] opening or toggling another level 1 panel
         [data-drawer-open]            the hamburger, for a fresh open  */
    if (closest(target, '[data-close], [data-overlay], [data-drawer-submenu-close], [data-drawer-submenu-trigger], [data-drawer-open]')) {
      closeAll();
    }
  }, false);

  /* Escape closes the current panel one level, it does not close the drawer.
     Bound on window in the capture phase so it runs before any handler the
     theme has on document, and stopImmediatePropagation keeps those handlers
     from also acting on the same key press. Both only happen while a level 2
     panel is actually open, so Escape behaves normally everywhere else. */
  window.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var openPanels = document.querySelectorAll('[data-lwc-dd].' + OPEN);
    if (!openPanels.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    close(openPanels[openPanels.length - 1], true);
  }, true);
})();